import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CategoryList } from '../components/CategoryList';
import { CategoryForm } from '../components/CategoryForm';
import type { Category } from '../types';
import { useSnackbar } from '../hooks/useSnackbar';
import { ToastNotification } from '../components/ToastNotification';

export const CategoryManagementPage: React.FC = () => {
  const [categoryFormOpen, setCategoryFormOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { snackbar, showSuccess, showError, hideSnackbar } = useSnackbar();

  const handleAddCategory = () => {
    setSelectedCategory(null);
    setIsEditing(false);
    setCategoryFormOpen(true);
  };

  const handleEditCategory = (category: Category) => {
    setSelectedCategory(category);
    setIsEditing(true);
    setCategoryFormOpen(true);
  };

  const handleCategorySaved = (category: Category) => {
    const wasEditing = isEditing;
    setCategoryFormOpen(false);
    setSelectedCategory(null);
    setIsEditing(false);
    setRefreshTrigger(prev => prev + 1);
    showSuccess(wasEditing ? 'Cập nhật danh mục thành công!' : 'Thêm danh mục thành công!');
  };

  const handleCategorySaveError = (error: string) => {
    showError(error);
  };

  return (
    <Box sx={{ p: 3 }}>
      <CategoryList
        onEdit={handleEditCategory}
        onAdd={handleAddCategory}
        refreshTrigger={refreshTrigger}
      />

      <CategoryForm
        open={categoryFormOpen}
        onClose={() => {
          setCategoryFormOpen(false);
          setSelectedCategory(null);
          setIsEditing(false);
        }}
        onSave={handleCategorySaved}
        onError={handleCategorySaveError}
        category={selectedCategory}
        title={isEditing ? 'Chỉnh sửa danh mục' : 'Thêm danh mục mới'}
      />

      <ToastNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={hideSnackbar}
      />
    </Box>
  );
};
